import { db } from './index';
import { collection, addDoc, Timestamp, updateDoc, DocumentReference, arrayUnion } from 'firebase/firestore';
import IProduct from '../types/IProduct';
import IList from '../types/IList';
import { query, where, getDocs, documentId, DocumentData, doc, deleteDoc,arrayRemove} from "firebase/firestore";


const listsCollectionRef = collection(db, "lists");

/* CREATE */
const addList = async (list: IList) => {
  try {
    await addDoc(listsCollectionRef, {
      title: list.title,
      createdAt: new Date(),
      completed: list.completed,
      items: list.items,
      user_id: list.user_id
    });
  } catch (err) {
    alert(err)
  }
}


const addProductToList = async (id: string, product: IProduct) => {
  const listDoc = doc(db, 'lists', id); 

  try {
    await updateDoc(listDoc, {"items": arrayUnion({...product, price: Number(product.price).toFixed(2)})})
  } catch (err) {
    alert(err)
  }
}

// READ 

async function getListById(id: string) {
  const q = query(listsCollectionRef, where(documentId(), "==", id));
  const querySnapshot = await getDocs(q);

  querySnapshot.forEach((doc) => {
    let objList = doc.data()
    
  });
  return
}

// UPDATE

async function updateCheckbox(checked: boolean, id: string, item: IProduct) {
  const listDoc = doc(db, 'lists', id);
  
  try{
    await updateDoc(listDoc, {"items": arrayRemove(item)})
    await updateDoc(listDoc, {"items": arrayUnion({...item, "checked": checked})})
  } catch (err) {
    alert(err)
  }    
}

async function updateProduct(id: string, item: IProduct, newItem: IProduct) {
  const listDoc = doc(db, 'lists', id);
  
  try{
    await updateDoc(listDoc, {"items": arrayRemove(item)})
    await updateDoc(listDoc, {"items": arrayUnion({...item, ...newItem})})
  } catch (err) {
    alert(err)
  }    
}


// DELETE  

const handleDeleteList = async (id: string) => {
  const listDoc = doc(db, 'lists', id);
  
  try{
    await deleteDoc(listDoc)
  } catch (err) {
    alert(err)
  }
}

const handleDeleteProduct = async (id: string, item: IProduct) => {
  const listDoc = doc(db, 'lists', id);
  
  try{
    await updateDoc(listDoc, {"items": arrayRemove(item)})
  } catch (err) {
    alert(err)
  }
}


function dateConverter(date: Date) {
  const day = date.getDate().toString();
  const month = date.getMonth() + 1;
  const year = date.getFullYear(); 
  const hour = date.getHours() + "h" + date.getMinutes() + "min";
  const formatedDate = `${day}/${month}/${year} às ${hour}`;
  return formatedDate;
}

function getTotal(list: IProduct[]) {
  let total = list.map((item: IProduct) => {
    if(item.checked === true) {
      if(item.price === " " || item.price === "" || item.price === undefined){
        item.price = 0;
        return item.price;
      } 
      if(item.unities !== undefined && item.unities > 1) return (Number(item!.price) * Number(item!.unities));
      return Number(item.price);
    } else {
      return 0
    }
  })
  let totalSum = total.reduce((a: number, b: number) => {
    return a + b
  });

  return totalSum.toFixed(2).toString().replace(".", ",");
}

async function saveListForLater(array: IProduct[], userId: string) {
  
  const q = query(listsCollectionRef, where("title", "==", "Salvo para a próxima compra"), where("user_id", "==", userId));
  const querySnapshot = await getDocs(q);
  console.log(userId);
  
  if(!querySnapshot.empty) {
    querySnapshot.forEach((doc) => {
      let objId = doc.id;
      if(array.length > 0) {
        array.forEach((item: IProduct) => {
          addProductToList(objId, item);
        })
      }
    });
  } else {
    let newList = {
      title: "Salvo para a próxima compra",
      createdAt: new Date(),
      completed: false,
      items: array,
      user_id: userId
    }
    if(array.length > 0) addList(newList);

  }

  
}

export { addList, getListById, updateCheckbox, updateProduct, handleDeleteProduct, handleDeleteList, addProductToList, dateConverter, getTotal, saveListForLater }


